module.exports = __webpack_public_path__ + "img/banner2.d21bc48.png";